import { CheckCircle2, AlertTriangle, ShieldCheck, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

function ShiftSlot({ label, count, onCount, onSignoff, testId }) {
  if (!count) {
    return (
      <Button variant="outline" className="h-14 w-full justify-start gap-2" onClick={onCount} data-testid={`${testId}-count`}>
        <Clock className="h-4 w-4 text-stone-400" /> {label}: count now
      </Button>
    );
  }
  const bad = count.mismatch;
  return (
    <div className={`rounded-lg border p-3 ${bad ? "border-rose-300 bg-rose-50 dark:bg-rose-950/30" : "border-emerald-200 bg-emerald-50 dark:bg-emerald-950/20"}`} data-testid={`${testId}-status`}>
      <div className="flex items-center justify-between gap-2">
        <div className={`flex items-center gap-1.5 font-semibold text-sm ${bad ? "text-rose-800" : "text-emerald-800"}`}>
          {bad ? <AlertTriangle className="h-4 w-4" /> : <CheckCircle2 className="h-4 w-4" />}
          {label}: {count.counted}/{count.expected}
        </div>
        <button className="text-xs underline text-stone-600" onClick={onCount} data-testid={`${testId}-recount`}>Recount</button>
      </div>
      <div className="text-[11px] text-stone-600 mt-0.5">{count.counted_by_name} · {count.counted_at ? new Date(count.counted_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : ""}</div>
      {bad && count.missing?.length > 0 && <div className="text-xs text-rose-900 mt-1 font-semibold" data-testid={`${testId}-missing`}>Missing: <span className="font-mono">{count.missing.join(", ")}</span></div>}
      {bad && count.note && <div className="text-xs text-rose-900 mt-1">{count.note}</div>}
      {bad && (count.signed_off ? (
        <div className="text-xs text-emerald-800 mt-1.5 flex items-center gap-1"><ShieldCheck className="h-3.5 w-3.5" /> Signed off by {count.signed_off_by_name}</div>
      ) : (
        <Button size="sm" className="mt-2 h-9 bg-rose-600 hover:bg-rose-700 gap-1.5" onClick={() => onSignoff(count)} data-testid={`${testId}-signoff`}>
          <ShieldCheck className="h-4 w-4" /> Supervisor sign-off
        </Button>
      ))}
    </div>
  );
}

export default function KnifeAreaCard({ area, onCount, onSignoff }) {
  const flagged = [area.start, area.end].some((c) => c?.mismatch && !c.signed_off);
  return (
    <div className={`panel p-4 space-y-3 ${flagged ? "ring-2 ring-rose-400" : ""}`} data-testid={`knife-area-${area.location_id}`}>
      <div className="flex items-baseline justify-between">
        <div className="font-display font-bold text-lg">{area.name}</div>
        <div className="text-xs text-stone-500">{area.knives?.length ? <span className="font-mono mr-2">{area.knives.join(" ")}</span> : null}Expected <span className="font-bold text-stone-800 dark:text-stone-100 tnum">{area.expected}</span></div>
      </div>
      <ShiftSlot label="Start" count={area.start} onCount={() => onCount(area, "start")} onSignoff={onSignoff} testId={`knife-${area.location_id}-start`} />
      {area.expected > 0 && !area.end && (
        <div className="text-[11px] font-bold uppercase tracking-wider text-amber-700" data-testid={`knife-${area.location_id}-end-due`}>End-of-shift count due</div>
      )}
      <ShiftSlot label="End" count={area.end} onCount={() => onCount(area, "end")} onSignoff={onSignoff} testId={`knife-${area.location_id}-end`} />
    </div>
  );
}
